import { z } from 'zod';

export const revolutOpenBankingCallbackGetResponseSchema = z.object({
  data: z.object({ success: z.string().optional() }),
  response: z.object({ date: z.string(), messages: z.array(z.string()), status: z.number(), type: z.string() }),
});
